var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-view"},[_c('el-row',{staticClass:"d-flex justify-content-center",staticStyle:{"margin-top":"10px"},attrs:{"gutter":50}},[_c('el-col',{attrs:{"span":10}},[_c('ProfileDataForm')],1),_c('el-col',{attrs:{"span":10}},[_c('PasswordChangeForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }